const IDLE_TIMEOUT = 15; // 15 seconds
const STUCKED_TIMEOUT = 5; // 5 seconds
const TRANSITION_BUFFER_MS = 80; // 80 milliseconds
const DUMMY_PROGRESS_INTERVAL_MS = 200; // 200 milliseconds
const BUFFER_MS = 100; // 100 milliseconds

export {
  IDLE_TIMEOUT,
  STUCKED_TIMEOUT,
  TRANSITION_BUFFER_MS,
  DUMMY_PROGRESS_INTERVAL_MS,
  BUFFER_MS,
};
